/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.uploadReceipt.internal

import features.uploadReceipt.internal.UploadReceiptUseCase.Params
import features.uploadReceipt.models.UploadReceiptResponseModel
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.krMultiPartForm.UploadReceiptRequestModel

internal class UploadReceiptUseCase : AsyncUseCase<UploadReceiptResponseModel, Params>() {

    internal class Params(
        val overrideHeaders: Map<String, String>? = null,
        val businessId: String,
        val uploadReceiptBodyRequest: UploadReceiptRequestModel
    )

    private val uploadReceiptService: UploadReceiptService = UploadReceiptServiceImpl()

    override suspend fun run(params: Params): Result<UploadReceiptResponseModel> {
        return uploadReceiptService.uploadReceipt(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId,
            uploadReceiptBodyRequest = params.uploadReceiptBodyRequest
        )
    }
}